import { Field, FieldProps } from 'formik'
import { forwardRef } from 'react'
import { InputComponent, InputComponentProps } from '../Input/Input'

interface FormikInputProps extends InputComponentProps {
  name: string
  autoFocus?: boolean
  [k: string]: any
}

const FormikInput = forwardRef<any, FormikInputProps>(
  ({ name, ...props }, ref) => {
    return (
      <Field name={name}>
        {({ field, meta }: FieldProps) => {
          return (
            <InputComponent
              isInvalid={meta.error}
              {...field}
              {...props}
              ref={ref}
            />
          )
        }}
      </Field>
    )
  }
)

export default FormikInput
